export const unsupportedElementSpec = {
  inline: false,
  group: 'block',
  attrs: {
    type: {
      default: 'unsupportedElement'
    },
    unsupportedTypeName: {
      default: ''
    },
    text: {
      default: ''
    }
  },
  parseDOM: [],
  toDOM(_node) {
    return ['div'];
  }
};